export enum AuthorStoreType {
  AUTHOR = 'author',
  NEWSROOM = 'newsroom',
}